export default __webpack_public_path__ + "static/media/Occult Gem of Dexterity.8d6a9919.jpg";